import styled from 'styled-components';

export const JsonFormWrapper = styled.div`
  .ant-input-password.ant-input-affix-wrapper-disabled .ant-input-suffix {
    display: none;
  }
`;
